import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e35e38ca"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "line-primari" }
const _hoisted_2 = { class: "line-aux" }

import { watch, onMounted, ref, reactive, Ref, HtmlHTMLAttributes, computed } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'TimePlannerComponent',
  props: /*#__PURE__*/_mergeModels({
    span: {},
    validator: { type: Function }
  }, {
    "modelValue": { required: true },
    "modelModifiers": {},
  }),
  emits: ["update:modelValue"],
  setup(__props: any, { expose: __expose }) {





__expose({ date_result, span_result })

const f = reactive({
    year: false,
    month: false,
    day: false,
    hour: false,
    minute: false,

    span: false
})


const M = _useModel<Date>(__props, "modelValue")





// const y = parseInt(input.date.year)

// if (y <= 1976) return null

// const m = parseInt(input.date.month)

// if (m < 1 || m > 12) return null;

// const d = parseInt(input.date.day)

// const buffer_a = new Date(y, m, 0).getDate();

// if (d < 1 || d > buffer_a) return null


// const h = parseInt(input.date.hour)

// if (h < 0 || h > 23) return null


// const mm = parseInt(input.date.minute)

// if (mm != 0 && mm != 15 && mm != 30 && mm != 45) return null

// if (mm < 0 || mm > 59) return null

const isCorrect = computed(() => correctnes.year && correctnes.month && correctnes.day && correctnes.hour && correctnes.minute && correctnes.span)

const validators = {

    year(y: number) {

        if (y <= 1976) return false

        if (props.validator != undefined) {

            const buffer = date_result()

            buffer.setFullYear(y)

            if (!props.validator(buffer)) return false
        }

        return true
    },
    month(m: number) {

        if (m < 1 || m > 12) return false

        if (props.validator != undefined) {

            const buffer = date_result()

            buffer.setMonth(m - 1)

            if (!props.validator(buffer)) return false
        }

        return true
    },
    day(d: number) {

        const buffer_a = new Date(model.date.year, model.date.month, 0).getDate();

        if (d < 1 || d > buffer_a) return false

        if (props.validator != undefined) {

            const buffer = date_result()

            buffer.setDate(d)

            if (!props.validator(buffer)) return false
        }

        return true
    },

    hour(h: number) {

        if (h < 0 || h > 23) return false

        if (props.validator != undefined) {

            const buffer = date_result()

            buffer.setHours(h)

            if (!props.validator(buffer)) return false
        }

        return true
    },

    minute(mm: number) {

        if (mm < 0 || mm > 59) return false

        if (props.validator != undefined) {

            const buffer = date_result()

            buffer.setMinutes(mm)

            if (!props.validator(buffer)) return false
        }

        return true
    }
}

function numberOrNull(v: string | null) {

    if (v == null) return null

    if (!isNumberString(v)) return null

    const buffer = parseInt(v)

    if (isNaN(buffer)) return null

    return buffer
}

const correctnes = reactive({
    year: true,
    month: true,
    day: true,
    hour: true,
    minute: true,
    span: true
})


function setupTargentSelection(element: HTMLInputElement | HTMLTextAreaElement) {

    if (element.value.length > 0) {

        element.setSelectionRange(0, element.value.length)
    }

}

const handlers =
{
    year: {
        input(payload: InputEvent) {

            const t = payload.currentTarget! as HTMLInputElement

            const n = numberOrNull(t.value)

            if (n != null && validators.year(n)) {
                correctnes.year = true
                model.date.year = n;

                //const buffer = M.value.setFullYear(model.date.year)

                //const xx = M.value

                M.value = date_result()

                if (t.value.length == 4) {
                    //move to minutes
                    focusAndSelect_ref(input_month)
                }
            }

            else correctnes.year = false
        },

        focus(event: FocusEvent) {

            const t = event.currentTarget as HTMLInputElement



            f.year = true

            //input.date.year = model.date.year.toString()

            t.value = model.date.year.toString()

            correctnes.year = true

            setupTargentSelection(t)
        },
        blur(event: FocusEvent) {

            f.year = false

            const t = event.currentTarget as HTMLInputElement

            //input.date.year = model.date.year.toString()// + 'f'

            t.value = model.date.year.toString()// + 'f'

            console.log('after update')
            console.log(t.value)

            correctnes.year = true
        }

    },

    month: {
        input(payload: InputEvent) {

            const t = payload.currentTarget! as (HTMLInputElement | HTMLTextAreaElement)

            const n = numberOrNull(t.value)

            if (n != null && validators.month(n)) {

                model.date.month = n
                correctnes.month = true
                M.value = date_result()

                if (t.value.length == 2) {
                    //move to minutes
                    focusAndSelect_ref(input_day)
                }
            }

            //else input.date.month = model.date.month.toString()
            else correctnes.month = false

        },
        focus(event: FocusEvent) {

            const t = event.currentTarget! as (HTMLInputElement | HTMLTextAreaElement)


            t.value = model.date.month.toString()

            //input.date.month = model.date.month.toString()

            correctnes.month = true

            setupTargentSelection(t)

        },
        blur(event: FocusEvent) {

            const t = event.currentTarget! as (HTMLInputElement | HTMLTextAreaElement)

            t.value = pad(model.date.month, 2)

            //input.date.month = pad(model.date.month, 2)

            correctnes.month = true
        }

    },

    day: {
        input(payload: InputEvent) {

            const t = payload.currentTarget! as (HTMLInputElement | HTMLTextAreaElement)

            const n = numberOrNull(t.value)

            if (n != null && validators.day(n)) {
                model.date.day = n
                correctnes.day = true
                M.value = date_result()

                if (t.value.length == 2) {
                    //move to minutes
                    focusAndSelect_ref(input_hour)
                }
            }

            //else input.date.day = model.date.day.toString()
            else correctnes.day = false

        },
        focus(event: FocusEvent) {

            const t = event.currentTarget! as (HTMLInputElement | HTMLTextAreaElement)

            t.value = model.date.day.toString()

            correctnes.day = true

            setupTargentSelection(t)
        },
        blur(event: FocusEvent) {

            const t = event.currentTarget! as (HTMLInputElement | HTMLTextAreaElement)



            t.value = pad(model.date.day, 2)

            correctnes.day = true
        }

    },
    hour: {
        input(payload: InputEvent) {

            const t = payload.currentTarget! as (HTMLInputElement | HTMLTextAreaElement)

            const n = numberOrNull(t.value)

            if (n != null && validators.hour(n)) {
                model.date.hour = n

                correctnes.hour = true

                M.value = date_result()

                if (t.value.length == 2) {
                    //move to minutes
                    focusAndSelect_ref(input_minute)
                }
            }

            //else input.date.hour = model.date.hour.toString()
            else correctnes.hour = false

        },
        focus(event: FocusEvent) {

            const t = event.currentTarget! as (HTMLInputElement | HTMLTextAreaElement)

            t.value = model.date.hour.toString()

            correctnes.hour = true

            setupTargentSelection(t)
        },
        blur(event: FocusEvent) {

            const t = event.currentTarget! as (HTMLInputElement | HTMLTextAreaElement)

            t.value = pad(model.date.hour, 2)

            correctnes.hour = true
        }

    },
    minute: {
        input(payload: InputEvent) {

            const t = payload.currentTarget! as (HTMLInputElement | HTMLTextAreaElement)

            const n = numberOrNull(t.value)

            if (n != null && validators.minute(n)) {

                model.date.minute = n
                correctnes.minute = true

                M.value = date_result()

                if (t.value.length == 2) {
                    //move to minutes
                    focusAndSelect_ref(input_span)
                }

            }

            //else input.date.minute = model.date.minute.toString()
            else correctnes.minute = false

        },
        focus(event: FocusEvent) {

            const t = event.currentTarget! as (HTMLInputElement | HTMLTextAreaElement)

            t.value = model.date.minute.toString()

            correctnes.minute = true

            setupTargentSelection(t)
        },
        blur(event: FocusEvent) {

            const t = event.currentTarget! as (HTMLInputElement | HTMLTextAreaElement)

            t.value = pad(model.date.minute, 2)

            correctnes.minute = true
        }

    }
}



// declares "count" prop, consumed by parent via v-model:count
//const count = defineModel('count')
// OR: declares "count" prop with options
//const date = defineModel<Date>('date', { type: Date, default: new Date() })
//const span = defineModel<Number>('span', { type: Number, default: 0 })

const props = __props

const model: { date: { year: number, month: number, day: number, hour: number, minute: number }, span: number } =

    reactive({
        date: {
            year: -1,
            month: -1,
            day: -1,
            hour: -1,
            minute: -1
        },
        span: 0
    })


// const input = reactive({
//     date: {
//         year: '',
//         month: '',
//         day: '',
//         hour: '',
//         minute: ''
//     },
//     span: 0
// })


watch(() => M.value, function (v) {

    updateInputModel(v)

})


watch(() => model.date.year, function (n, o) {

    if (o != -1) {
        console.log('changed year event')
    }
})


function updateInputModel(v: Date) {

    const y = v.getFullYear()

    if (y != model.date.year) {
        model.date.year = y

        if (input_year.value != null) input_year.value.value = pad(model.date.year, 4)
    }

    const m = v.getMonth()

    if (m + 1 != model.date.month) {

        model.date.month = m + 1

        if (input_month.value != null) input_month.value.value = pad(model.date.month, 2)
    }

    const d = v.getDate()

    if (d != model.date.day) {

        model.date.day = d

        if (input_day.value != null) input_day.value.value = pad(model.date.day, 2)
    }

    const h = v.getHours()

    if (h != model.date.hour) {

        model.date.hour = h

        if (input_hour.value != null) input_hour.value.value = pad(model.date.hour, 2)
    }

    const mm = v.getMinutes()

    if (mm != model.date.minute) {

        model.date.minute = mm

        if (input_minute.value != null) input_minute.value.value = pad(model.date.minute, 2)
    }

}

onMounted(() => {

    updateInputModel(M.value)
})



function pad(num: number, padlen: number) {
    const pad_char = '0';
    let pad = num.toString()

    if (pad.length >= padlen) return pad

    pad = new Array(1 + padlen).join(pad_char);
    return (pad + num).slice(-pad.length);
}


function setDate(x: Date) {

    model.date.year = x.getFullYear()
    model.date.month = x.getMonth() + 1
    model.date.day = x.getDate()

    model.date.hour = x.getHours()
    model.date.minute = x.getMinutes()
}

function date_result() {

    //const buffer = dateOrNull()

    return new Date(model.date.year, model.date.month - 1, model.date.day, model.date.hour, model.date.minute)

    //if (buffer == null) throw new Error('date is null')

    //return buffer
}

function span_result() {

    return model.span
}

// function dateOrNull(){

//     try {

//         const x = model.date

//         return  new Date(x.year, x.month - 1, x.day, x.hour, x.minute)

//     } catch (error) {

//         return null
//     }
// }

//date.value

//const input_year = ref('input_year')

const input_year = ref<InstanceType<typeof HTMLInputElement> | null>(null)
const input_month = ref<InstanceType<typeof HTMLInputElement> | null>(null)
const input_day = ref<InstanceType<typeof HTMLInputElement> | null>(null)
const input_hour = ref<InstanceType<typeof HTMLInputElement> | null>(null)
const input_minute = ref<InstanceType<typeof HTMLInputElement> | null>(null)
const input_span = ref<InstanceType<typeof HTMLInputElement> | null>(null)


function isNumberString(value: string) {


    return /^\d*\.?\d*$/.test(value) // Allow digits and '.' only, using a RegExp.
}




function focusAndSelect_ref(element: (Ref<HTMLInputElement | null> | Ref<HTMLInputElement | null>)): void {

    if (element.value != null) {
        const e = element.value

        focusAndSelect(e)
    }
}



function focusAndSelect(element: (HTMLInputElement | HTMLTextAreaElement)): void {

    element.focus()
    console.log('focus nad select*')
    console.log(`fss:${element.selectionStart} fsefocus: ${element.selectionEnd}`)
    //element.setSelectionRange(0, element.value.length);
}

onMounted(() => {

    if (input_year.value != null) setInputFilter(input_year.value, isNumberString, '')
    if (input_month.value != null) setInputFilter(input_month.value, isNumberString, '')
    if (input_day.value != null) setInputFilter(input_day.value, isNumberString, '')
    if (input_hour.value != null) setInputFilter(input_hour.value, isNumberString, '')
    if (input_minute.value != null) setInputFilter(input_minute.value, isNumberString, '')

    input_year.value!.addEventListener('keydown', function (this: HTMLInputElement, e: KeyboardEvent) {

        console.log(this.value.length)
        console.log(this.selectionStart)


        if (e.code == 'ArrowRight' && this.value.length == this.selectionEnd) {
            focusAndSelect_ref(input_month)
            e.preventDefault()
        }
    })

    input_month.value!.addEventListener('keydown', function (this: HTMLInputElement, e: KeyboardEvent) {

        if (e.code == 'ArrowRight' && this.value.length == this.selectionEnd) {
            focusAndSelect_ref(input_day)
            e.preventDefault()
        }

        if (e.code == 'ArrowLeft' && 0 == this.selectionStart) {
            focusAndSelect_ref(input_year)
            e.preventDefault()
        }


    })

    input_day.value!.addEventListener('keydown', function (this: HTMLInputElement, e: KeyboardEvent) {

        if (e.code == 'ArrowRight' && this.value.length == this.selectionEnd) {
            focusAndSelect_ref(input_hour)
            e.preventDefault()
        }

        if (e.code == 'ArrowLeft' && 0 == this.selectionStart) {
            focusAndSelect_ref(input_month)
            e.preventDefault()
        }
    })

    input_hour.value!.addEventListener('keydown', function (this: HTMLInputElement, e: KeyboardEvent) {

        if (e.code == 'ArrowRight' && this.value.length == this.selectionEnd) {
            focusAndSelect_ref(input_minute)
            e.preventDefault()
        }

        if (e.code == 'ArrowLeft' && 0 == this.selectionStart) {
            focusAndSelect_ref(input_day)
            e.preventDefault()
        }

    })

    input_minute.value!.addEventListener('keydown', function (this: HTMLInputElement, e: KeyboardEvent) {

        if (e.code == 'ArrowRight' && this.value.length == this.selectionEnd) {
            focusAndSelect_ref(input_span);
            e.preventDefault()

        }

        if (e.code == 'ArrowLeft' && 0 == this.selectionStart) {
            focusAndSelect_ref(input_hour)
            e.preventDefault()
        }
    })


    input_span.value!.addEventListener('keydown', function (this: HTMLInputElement, e: KeyboardEvent) {

        // if (e.code == 'ArrowRight') {

        //     if (input_minute.value != null) input_minute.value.focus()
        // }

        if (e.code == 'ArrowLeft' && 0 == this.selectionStart) {
            focusAndSelect_ref(input_minute)
            e.preventDefault()
        }
    })


})

// function isValidDate() {

//     const x = dateOrNull() != null

//     if (x != true) {

//         //old date write to input
//     }

//     return x
// }

// function dateOrNull() {

//     try {


//         const y = parseInt(input.date.year)

//         if (y <= 1976) return null

//         const m = parseInt(input.date.month)

//         if (m < 1 || m > 12) return null;

//         const d = parseInt(input.date.day)

//         const buffer_a = new Date(y, m, 0).getDate();

//         if (d < 1 || d > buffer_a) return null


//         const h = parseInt(input.date.hour)

//         if (h < 0 || h > 23) return null


//         const mm = parseInt(input.date.minute)

//         if (mm != 0 && mm != 15 && mm != 30 && mm != 45) return null

//         //if (mm < 0 || mm > 59) return null


//         return new Date(y, m, d, h, mm)




//     } catch (error) {

//         return null
//     }
// }

function setInputFilter(textbox: Element, inputFilter: (value: string) => boolean, errMsg: string): void {
    ["input", "keydown", "keyup", "mousedown", "mouseup", "select", "contextmenu", "drop", "focusout"].forEach(function (event) {
        textbox.addEventListener(event, function (this: (HTMLInputElement | HTMLTextAreaElement) & { oldValue: string; oldSelectionStart: number | null, oldSelectionEnd: number | null }) {
            if (inputFilter(this.value)) {

                this.oldValue = this.value;
                this.oldSelectionStart = this.selectionStart;
                this.oldSelectionEnd = this.selectionEnd;
            }

            else if (Object.prototype.hasOwnProperty.call(this, "oldValue")) {

                this.value = this.oldValue;

                if (this.oldSelectionStart !== null &&
                    this.oldSelectionEnd !== null) {
                    this.setSelectionRange(this.oldSelectionStart, this.oldSelectionEnd);
                }
            }
            else this.value = "";
        });
    });
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("input", {
        class: _normalizeClass(["numpad-x4", { 'input-error': !correctnes.year }]),
        maxlength: "4",
        type: "text",
        ref_key: "input_year",
        ref: input_year,
        onBlur: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (handlers.year.blur && handlers.year.blur(...args))),
        onFocus: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (handlers.year.focus && handlers.year.focus(...args))),
        onInput: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (handlers.year.input && handlers.year.input(...args)))
      }, null, 34),
      _createElementVNode("input", {
        class: _normalizeClass(["numpad-x2", { 'input-error': !correctnes.month }]),
        maxlength: "2",
        type: "text",
        ref_key: "input_month",
        ref: input_month,
        onBlur: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (handlers.month.blur && handlers.month.blur(...args))),
        onFocus: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (handlers.month.focus && handlers.month.focus(...args))),
        onInput: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (handlers.month.input && handlers.month.input(...args)))
      }, null, 34),
      _createElementVNode("input", {
        class: _normalizeClass(["numpad-x2", { 'input-error': !correctnes.day }]),
        maxlength: "2",
        type: "text",
        ref_key: "input_day",
        ref: input_day,
        onBlur: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (handlers.day.blur && handlers.day.blur(...args))),
        onFocus: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (handlers.day.focus && handlers.day.focus(...args))),
        onInput: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (handlers.day.input && handlers.day.input(...args)))
      }, null, 34)
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("input", {
        class: _normalizeClass(["numpad-x2", { 'input-error': !correctnes.hour }]),
        maxlength: "2",
        type: "text",
        ref_key: "input_hour",
        ref: input_hour,
        onBlur: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (handlers.hour.blur && handlers.hour.blur(...args))),
        onFocus: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (handlers.hour.focus && handlers.hour.focus(...args))),
        onInput: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (handlers.hour.input && handlers.hour.input(...args)))
      }, null, 34),
      _createTextVNode(" : "),
      _createElementVNode("input", {
        class: _normalizeClass(["numpad-x2", { 'input-error': !correctnes.minute }]),
        maxlength: "2",
        type: "text",
        ref_key: "input_minute",
        ref: input_minute,
        onBlur: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (handlers.minute.blur && handlers.minute.blur(...args))),
        onFocus: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (handlers.minute.focus && handlers.minute.focus(...args))),
        onInput: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (handlers.minute.input && handlers.minute.input(...args)))
      }, null, 34),
      _createTextVNode("   "),
      _createElementVNode("input", {
        class: "timelength",
        type: "text",
        ref_key: "input_span",
        ref: input_span
      }, null, 512)
    ])
  ]))
}
}

})